module.exports = __webpack_public_path__ + "media/images/logos/external/instagram_logo-5139d56ff0927cddd11f7ba147dac328.svg";